// extracted by mini-css-extract-plugin
export var Pagination = "Slider-module--Pagination--956e1";
export var bullet = "Slider-module--bullet--9bbcc";
export var bulletActive = "Slider-module--bulletActive--47f22";
export var slider = "Slider-module--slider--2d103";
export var sliderSwiperReady = "Slider-module--sliderSwiperReady--68e11";
export var swiperBottomPadding = "Slider-module--swiperBottomPadding--27e82";